import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_input = _resolveComponent("q-input");
    return (_openBlock(), _createBlock(_component_q_input, _mergeProps(_ctx.props, {
        ref: "inputElement",
        "onUpdate:modelValue": _ctx.onUpdateValue,
        onBlur: _ctx.onFormatValue
    }), _createSlots({ _: 2 }, [
        _renderList(_ctx.$slots, (_, slot) => {
            return {
                name: slot,
                fn: _withCtx((scope) => [
                    _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope || {})))
                ])
            };
        })
    ]), 1040, ["onUpdate:modelValue", "onBlur"]));
}
